module.exports = __webpack_public_path__ + "img/rgas_rland.8ac9efb.png";